import { Button } from "design-system/atoms/Button"
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { Card } from "design-system/molecules/Card"
import { useTranslation } from "react-i18next"
import { CompletedImportState } from "./ImportFlow"

type Props = {
  state: CompletedImportState
  onClose: () => void
}

export function ImportCompleteStep({ state, onClose }: Props) {
  const { t } = useTranslation()

  const stats: Array<{
    label: string
    value: number
    tone: "neutral" | "positive" | "info" | "destructive"
  }> = [
    {
      label: t("customers.imports.complete.stats.total"),
      value: state.totalRows,
      tone: "neutral",
    },
    {
      label: t("customers.imports.complete.stats.created"),
      value: state.createdCount,
      tone: "positive",
    },
    {
      label: t("customers.imports.complete.stats.updated"),
      value: state.updatedCount,
      tone: "info",
    },
    {
      label: t("customers.imports.complete.stats.failed"),
      value: state.failedCount,
      tone: "destructive",
    },
  ]

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t("customers.imports.complete.title")}</DialogTitle>
        <DialogDescription>{t("customers.imports.complete.description")}</DialogDescription>
      </DialogHeader>
      <div className="grid grid-cols-2 gap-3 py-4">
        {stats.map((stat) => (
          <Card key={stat.label} className="flex flex-col gap-1 p-4">
            <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              {stat.label}
            </span>
            <span
              className={
                stat.tone === "destructive"
                  ? "text-2xl font-semibold text-destructive"
                  : "text-2xl font-semibold text-foreground"
              }
            >
              {stat.value.toLocaleString()}
            </span>
          </Card>
        ))}
      </div>
      <DialogFooter>
        <Button onClick={onClose}>{t("customers.imports.complete.close")}</Button>
      </DialogFooter>
    </>
  )
}
